import React from 'react'

import type {
  IBlock,
  IBlockPayloadImage,
  IBlockPayloadVideo,
  IBlockPayloadContent,
  IBlockPayloadSlider,
  IBlockPayloadForm,
  IBlockPayloadCountdown,
  IBlockPayloadBankAccounts,
} from '../../types'
import { ImageRenderer } from './renderers/ImageRenderer'
import { VideoRenderer } from './renderers/VideoRenderer'
import { ContentRenderer } from './renderers/ContentRenderer'
import { SliderRenderer } from './renderers/SliderRenderer'
import { FormRenderer } from './renderers/FormRenderer'
import { CountdownRenderer } from './renderers/CountdownRenderer'
import { BankAccountsRenderer } from './renderers/BankAccountsRenderer'

interface BlockRendererProps {
  block: IBlock
}

export const BlockRenderer: React.FC<BlockRendererProps> = ({ block }) => {
  switch (block.type) {
    case 'IMAGE':
      return <ImageRenderer payload={block.payload as IBlockPayloadImage} />
    case 'VIDEO':
      return <VideoRenderer payload={block.payload as IBlockPayloadVideo} />
    case 'CONTENT':
      return <ContentRenderer payload={block.payload as IBlockPayloadContent} />
    case 'SLIDER':
      return <SliderRenderer payload={block.payload as IBlockPayloadSlider} />
    case 'FORM':
      return <FormRenderer payload={block.payload as IBlockPayloadForm} />
    case 'COUNTDOWN':
      return <CountdownRenderer payload={block.payload as IBlockPayloadCountdown} />
    case 'BANK_ACCOUNTS':
      return <BankAccountsRenderer payload={block.payload as IBlockPayloadBankAccounts} />
    default:
      return null
  }
}
